<template>
  <span class="c-counter">
    <a
      href="#"
      class="btn btn-dark btn-sm"
      :style="value === 0 ? 'opacity: 0.5' : ''"
      @click.prevent="minus()"
    >
      -
    </a>
    <b style="margin: 0 0.5rem">
      {{ value }}
    </b>
    <a
      href="#"
      class="btn btn-success btn-sm"
      @click.prevent="plus()"
    >
      +
    </a>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    minus() {
      const { value, min, step } = this;
      if (value > 0) {
        if (min >= value) {
          this.$emit('input', 0);
        } else {
          this.$emit('input', value - step);
        }
        this.$emit('minus');
      }
    },
    plus() {
      const {
        value,
        min,
        max,
        step,
      } = this;
      if (value < max) {
        if (value === 0) {
          this.$emit('input', value + min);
        } else {
          this.$emit('input', value + step);
        }
        this.$emit('plus');
      }
    },
  },
};
</script>

<style scoped>
.c-counter{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
}
</style>
